import type { PropsWithChildren, FunctionComponent } from 'react'
import { useCallback } from 'react'
import { IconButton } from '@retailer-platform/shared-components/src/tds'
import { EditIcon } from '@instacart/ids-core'
import { useGoToEditStoreGroup } from '../../../utils/navigation.hooks'
import { useTrackSingleStoreEditClicked } from '@retailer-platform/domain-store-hours-bulk'

interface Props {
  storeGroupId: string
  onEditClicked: (storeGroupId: string) => void
}

export const StoreGroupsListTableEditButton: FunctionComponent<PropsWithChildren<Props>> = ({
  storeGroupId,
  onEditClicked,
}) => {
  const goToEditStoreGroup = useGoToEditStoreGroup(storeGroupId)

  // bad linting
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const editAction = onEditClicked ? () => onEditClicked(storeGroupId) : goToEditStoreGroup
  const trackStoreHoursEvent = useTrackSingleStoreEditClicked()
  const editActionTrack = useCallback(() => {
    trackStoreHoursEvent()
    editAction()
  }, [editAction, trackStoreHoursEvent])

  return (
    <IconButton
      variant="tertiary"
      icon={EditIcon}
      onClick={editActionTrack}
      data-testid="store-group-edit-button"
    />
  )
}
